import React, { Component } from 'react'
import Collapsible from 'react-collapsible'
import { FormBuilderObjects } from '../variables/formBuilderData'
import { checkTranslation, translate } from '../utils/useful'

export default class FieldsList extends Component {

    state = {
        main: true,
    }

    componentDidMount() { }

    changeCollapse = () => {
        let main = this.state.main
        this.setState({ main: !main })
    }

    render() {
        return (
            <div className='' style={{ zIndex: 1, backgroundColor: "#fff", borderBottom: '1px solid #eee' }}>
                {/* <button className='flexcb w-100' style={{}} onClick={() => this.changeCollapse()}>
                    <p className='font-size-14 weight-500' style={{ color: "#4E4CCC" }}>{translate('Main')}</p>
                    <img className={'transition  ' + (this.state.main ? 'rotate-180' : '')} src='/assets/icons/arrow-up-purple.svg' />
                </button> */}
                <p className='px-3 text-smaller mt-2 color-gray-2'>{translate("Select the field type to create the field, you will set the information in the next step")}</p>
                <Collapsible open={this.state.main} transitionTime={100}>
                    {Object.values(FormBuilderObjects).map((prop, index) => {
                        return (
                            <div className='w-100 py-1 px-1 bb-gray'>
                                <button className='flexc hover-gray br-10 p-2 w-100 bb-gray' onClick={() => this.props.setField(prop)}>
                                    <div className='flexcc mrd-3'>
                                        <img width={30} className='p-1' src={prop.icon} />
                                    </div>
                                    <div className='text-start'>
                                        <p className='font-size-14 main-c2 '>{checkTranslation(prop.label)}</p>
                                    </div>
                                </button>
                            </div>
                        )
                    })}
                </Collapsible>
            </div>
        )
    }
}